const htmlLessons = [
  {
    title: "HTML Basic Structure",
    code: `<!DOCTYPE html>
<html>
<head>
    <title>My Page</title>
</head>
<body>
    <h1>Welcome</h1>
    <p>First web page.</p>
</body>
</html>`
  },
  {
    title: "Headings & Paragraphs",
    code: `<!DOCTYPE html>
<html>
<body>
    <h1>Main Heading</h1>
    <h2>Subheading</h2>
    <p>This is a paragraph.</p>
    <p>Another paragraph with <strong>bold</strong> text.</p>
    <p>Line<br>break<br>example.</p>
</body>
</html>`
  },
  {
    title: "Text Formatting",
    code: `<!DOCTYPE html>
<html>
<body>
    <p><b>Bold text</b></p>
    <p><i>Italic text</i></p>
    <p><u>Underlined</u></p>
    <p><mark>Highlighted</mark></p>
    <p>H<sub>2</sub>O and x<sup>2</sup></p>
    <p><code>Code example</code></p>
</body>
</html>`
  },
  {
    title: "Links",
    code: `<!DOCTYPE html>
<html>
<body>
    <a href="https://google.com">Visit Google</a>
    <a href="#section1">Jump to section</a>
    <a href="mailto:test@email.com">Email us</a>
    <br><br><br>
    <h2 id="section1">Section 1</h2>
    <p>Section content here.</p>
</body>
</html>`
  },
  {
    title: "Images",
    code: `<!DOCTYPE html>
<html>
<body>
    <h2>Basic Image</h2>
    <img src="image.jpg" alt="Sample image">
    
    <h2>Image as Link</h2>
    <a href="page.html">
        <img src="logo.png" alt="Logo">
    </a>
    
    <h2>Figure with Caption</h2>
    <figure>
        <img src="photo.jpg" alt="Photo">
        <figcaption>Image caption</figcaption>
    </figure>
</body>
</html>`
  },
  {
    title: "Lists",
    code: `<!DOCTYPE html>
<html>
<body>
    <h2>Unordered List</h2>
    <ul>
        <li>Apple</li>
        <li>Banana</li>
        <li>Orange</li>
    </ul>
    
    <h2>Ordered List</h2>
    <ol>
        <li>First step</li>
        <li>Second step</li>
        <li>Third step</li>
    </ol>
    
    <h2>Description List</h2>
    <dl>
        <dt>HTML</dt>
        <dd>Structures web content</dd>
        <dt>CSS</dt>
        <dd>Styles web content</dd>
    </dl>
</body>
</html>`
  },
  {
    title: "Basic Tables",
    code: `<!DOCTYPE html>
<html>
<body>
    <table border="1">
        <tr>
            <th>Name</th>
            <th>Age</th>
            <th>City</th>
        </tr>
        <tr>
            <td>Rajan</td>
            <td>25</td>
            <td>Delhi</td>
        </tr>
        <tr>
            <td>Priya</td>
            <td>22</td>
            <td>Mumbai</td>
        </tr>
    </table>
</body>
</html>`
  },
  {
    title: "Simple Form",
    code: `<!DOCTYPE html>
<html>
<body>
    <form>
        <label>Name:</label>
        <input type="text" name="name">
        
        <label>Email:</label>
        <input type="email" name="email">
        
        <label>Password:</label>
        <input type="password" name="password">
        
        <label>Message:</label>
        <textarea name="message"></textarea>
        
        <button type="submit">Submit</button>
    </form>
</body>
</html>`
  },
  {
    title: "Form Input Types",
    code: `<!DOCTYPE html>
<html>
<body>
    <form>
        <input type="text" placeholder="Text input">
        <input type="email" placeholder="Email">
        <input type="number" placeholder="Number">
        <input type="date">
        <input type="color">
        <input type="file">
        
        <select>
            <option>Option 1</option>
            <option>Option 2</option>
        </select>
        
        <input type="checkbox"> Checkbox
        <input type="radio" name="group"> Radio 1
        <input type="radio" name="group"> Radio 2
    </form>
</body>
</html>`
  },
  {
    title: "Semantic HTML",
    code: `<!DOCTYPE html>
<html>
<body>
    <header>
        <h1>Website Header</h1>
        <nav>
            <a href="#home">Home</a>
            <a href="#about">About</a>
        </nav>
    </header>
    
    <main>
        <article>
            <h2>Article Title</h2>
            <p>Article content here.</p>
        </article>
        
        <aside>
            <p>Sidebar content</p>
        </aside>
    </main>
    
    <footer>
        <p>Footer content</p>
    </footer>
</body>
</html>`
  },
  {
    title: "HTML Entities",
    code: `<!DOCTYPE html>
<html>
<body>
    <p>Less than: &lt;</p>
    <p>Greater than: &gt;</p>
    <p>Ampersand: &amp;</p>
    <p>Copyright: &copy;</p>
    <p>Trademark: &trade;</p>
    <p>Non-breaking space: Hello&nbsp;World</p>
    <p>Pi: &pi; and Infinity: &infin;</p>
</body>
</html>`
  },
  {
    title: "Metadata & SEO",
    code: `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Page Title</title>
    <meta name="description" content="Page description">
    <meta name="keywords" content="html, web">
</head>
<body>
    <h1>Content goes here</h1>
    <p>This page has proper metadata.</p>
</body>
</html>`
  },
  {
    title: "Accessibility Basics",
    code: `<!DOCTYPE html>
<html>
<body>
    <header role="banner">
        <nav aria-label="Main menu">
            <a href="#home">Home</a>
            <a href="#about">About</a>
        </nav>
    </header>
    
    <main role="main">
        <h1>Accessible Page</h1>
        <img src="image.jpg" alt="Descriptive alt text">
        
        <form>
            <label for="name">Name:</label>
            <input type="text" id="name" aria-required="true">
            
            <button type="submit">Submit</button>
        </form>
    </main>
    
    <footer role="contentinfo">
        <p>Footer content</p>
    </footer>
</body>
</html>`
  }
];

export default htmlLessons;